import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkProps } from 'react-router-dom';
import { Link as ReactLink } from 'react-router-dom';

interface LinkPropType extends Omit<LinkProps, 'to'> {
	href?: string;
	to?: string;
}

export const Link = forwardRef<HTMLAnchorElement, LinkPropType>((props, ref) => {
	const { href, children, to, ...linkProps } = props;
	const { language } = useTranslation().i18n;
	const hrefPath = href && href.startsWith('/') ? `${window.location.origin}/${language}${href}` : href;
	const toPath = to && to.startsWith('/') ? `${window.location.origin}/${language}${to}` : to;
	const Element = href ? 'a' : ReactLink;

	return (
		<Element ref={ref} to={toPath!} href={hrefPath} {...linkProps}>
			{children}
		</Element>
	);
});

